<div>
    <h2>Grunddaten</h2>
    <div class="mini-grid-product-type">
        <mat-form-field>
            <input matInput placeholder="Hersteller" [value]="organisationService.activeItem.organisationName"
                disabled />
        </mat-form-field>
        <mat-form-field>
            <input matInput placeholder="Produktkategorie" [value]="product.category" disabled />
        </mat-form-field>
    </div>

    <mat-form-field style="margin-bottom: 12px;" class="fullWidth">
        <input matInput placeholder="Produktname" [value]="product.name" disabled />
    </mat-form-field>

    <div class="mg-bt-2rem">
        <h3>Kurzbeschreibung des Produkts</h3>
        <div *ngIf="product.description" [innerHTML]="product.description" class="product-description">
        </div>
        <div *ngIf="!product.description" class="no-data-message">
            <em>Keine Beschreibung des Produkts angegeben</em>
        </div>
    </div>

    <mat-form-field class="fullWidth mg-bt-2rem">
        <input matInput placeholder="Link zur Produktwebsite" [value]="product.url" disabled />
    </mat-form-field>

    <div class="mg-bt-2rem">
        <h3>Stärken des Produkts</h3>
        <div class="features-list">
            <div *ngFor="let productFeature of productFeatures" class="feature-item">
                <span> {{ productFeature }} </span>
            </div>
            <div *ngIf="productFeatures.length === 0" class="no-data-message">
                <em>Keine Stärken angegeben</em>
            </div>
        </div>
    </div>
</div>

<!-- Step 2  -->
<div class="mg-bt-2rem">
    <h2>Gallerie und Dateien</h2>
    <div class="files-container">
        <div class="first-row-productfiles">
            <div *ngIf="product.fileId">
                <h3>Logo</h3>
                <img [src]="getImagePath(product.fileId)" alt="Hochgeladenes Produktlogo" class="product-logo">
            </div>
            <div *ngIf="product.documentFileIds.length > 0">
                <h3>Dokumente</h3>
                <app-detail-display-document-list [fileIds]="product.documentFileIds" [dataType]="dataTypeEnum.PRODUCT"
                    [onSummary]="true"></app-detail-display-document-list>
            </div>
        </div>
        <div *ngIf="product.galleryFileIds.length > 0">
            <h3>Produktgalerie</h3>
            <div class="gallery-container">
                <div *ngFor="let galleryId of product.galleryFileIds; let i = index" class="gallery-item">
                    <img class="gallery-img" [src]="getImagePath(galleryId)" />
                </div>
            </div>
        </div>
    </div>
    <!-- <div>
      <app-logo
        [fileId]="product.fileId"
        [fullView]="true"
        (logoChanged)="product.fileId = $event"
      ></app-logo>
      <app-product-files
        [documentFileIds]="product.documentFileIds"
        [galleryFileIds]="product.galleryFileIds"
        [logoId]="product.fileId"
        [galleryTitle]="'Produktgalerie'"
        (logoChanged)="product.fileId = $event"
      ></app-product-files>
    </div> -->
</div>

<!-- Step 3 -->
<div>
    <h2>Variante und Version</h2>

    <div style="margin-bottom: 12px;">
        <mat-form-field class="fullWidth">
            <input matInput placeholder="Variantenname" [value]="product.productVariants[0].name" disabled />
        </mat-form-field>
        <mat-form-field class="fullWidth">
            <input matInput placeholder="Variantenbeschreibung" [value]="product.productVariants[0].description"
                disabled />
        </mat-form-field>

        <div class="mini-grid-product-type">
            <mat-form-field class="fullWidth">
                <input matInput placeholder="Versionsname" [value]="product.productVariants[0].variantVersions[0].name"
                    disabled />
            </mat-form-field>
            <mat-form-field class="fullWidth">
                <input matInput placeholder="Status der Version"
                    [value]="product.productVariants[0].variantVersions[0].status" disabled />
            </mat-form-field>
        </div>

        <!-- <mat-form-field class="fullWidth">
            <input matInput placeholder="Versionsbeschreibung"
                [value]="product.productVariants[0].variantVersions[0].description" disabled />
        </mat-form-field> -->
    </div>

    <div class="mg-bt-2rem">
        <h3>Produkttypen</h3>
        <app-product-type-group-feature-display
            *ngIf="product.productVariants && product.productVariants.length && showPTG"
            [variantPTGFeaturesList]="product.productVariants"
            [comparisonMode]="'variant'"></app-product-type-group-feature-display>
        <div *ngIf="product.productVariants[0].variantVersions[0].ptgVersions.length === 0 " class="no-data-message">
            <em>Keine Produkttypen angegeben</em>
        </div>
    </div>

    <div class="mg-bt-2rem">
        <h3>Produktabhängigkeit</h3>
        <table *ngIf="product.relatedProducts.length > 0">
            <tbody>
                <tr *ngFor="let relatedProduct of product.relatedProducts" class="not">
                    <td class="wider">
                        <p>
                            {{
                            productService.getRelatedProductNameFromId(
                            relatedProduct
                            )
                            }}
                        </p>
                    </td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="product.relatedProducts.length === 0" class="no-data-message">
            <em>Keine Produktabhängigkeiten angegeben</em>
        </div>
    </div>
</div>

<!-- Step 4 -->
<div>
    <h2>Übergeordnete Auswahlkriterien</h2>
    <div class="selectedFeatureContainer">
        <div *ngFor="let group of groupedSelectedFeaturesArray" class="selectedFeatureGroup">
            <h4 class="feature-headline-h4 pad-lft">{{ group.featureName }}</h4>
            <div *ngFor="let entry of group.entries" class="selectedFeatureEntry">
                <span>{{ entry.name }}</span>
            </div>
        </div>
    </div>
    <div *ngIf="groupedSelectedFeaturesArray.length === 0" class="no-data-message">
        <em>Keine Übergeordnete Auswahlkriterien angegeben</em>
    </div>
</div>